import React from 'react';

import ReactModal from 'react-modal';
import { Card } from 'react-bootstrap';
import { translate } from 'react-i18next';
import IconDelete from 'assets/img/icon/icon_delete.png'

import styled from 'styled-components';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    width: '415px',
    transform: 'translate(-50%, -50%)',
    bottom: 'auto',
    backgroundColor: '#1C192C',
    border: 'none',
  },
  overlay: {
    backgroundColor: 'transparent',
    zIndex: '3',
  },
};

const StyleBtn = styled.button`
  padding: 8px 25px;
  height: 30px;
  border-radius: 3px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  width: 135px;

  &:hover,
  &:focus,
  &:active {
    outline: none;
    color: #f0b90b;
    border-color: #f0b90b;
    background: #878379;
  }
`;

const StyleBtnOutline = styled(StyleBtn)`
  color: #f0b90b;
  border: 1px solid #f0b90b;
  background: transparent;
`;

const StyleBtnSubmit = styled(StyleBtn)`
  color: #27272d;
  border: 1px solid #f0b90b;
  background: #f0b90b;
`;

const StyledText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--half_white);
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 24px;

  img{
    width: 44px;
    height: 44px;
    margin-bottom: 20px;
  }
`;

function ConfirmDelSignalModal(props) {
  const { onClose, onAccept, t } = props;

  return (
    <ReactModal
      isOpen={true}
      contentLabel="onRequestClose Example"
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      style={customStyles}
    >
      <Card
        style={{ borderRadius: '10px', background: 'transparent' }}
        className="border-0"
      >
        {/* <Card.Header
          className="text-center"
          style={{
            background: 'var(--sub-nav)',
            borderRadius: '5px 5px 0px 0px',
            color: 'var(--half_white)',
            fontSize: '13px',
            padding: '5px 15px',
          }}
        >
          Xác nhận
        </Card.Header> */}
        <Card.Body style={{ backgroundColor: 'var(--bg-th-even)' }}>
          <div className="form-search-head d-flex flex-column justify-content-center align-items-center">
            <StyledText>
              <img src={IconDelete} alt="" />
              <span>Xác nhận xóa tín hiệu</span>
            </StyledText>
            <div className="d-flex align-items-center justify-content-center">
              <StyleBtnOutline onClick={onClose}>Hủy</StyleBtnOutline>
              <StyleBtnSubmit className='ml-2' onClick={onAccept}>
                Xác nhận
              </StyleBtnSubmit>
            </div>
          </div>
        </Card.Body>
      </Card>
    </ReactModal>
  );
}

export default translate('translations')(ConfirmDelSignalModal);
